import { createReducer, on } from "@ngrx/store";
import { produce } from "immer";
import { IProfileState } from "../../models/state/profile/profile-state";
import { ProfileStateAction } from "./profile-state.actions";

export const initialState: IProfileState = {
  name: '',
  email: '',
  language: 'en-GB',
}

export const profileStateReducere = createReducer(
  initialState,
  on(ProfileStateAction.setLanguage, (state, newState) => {
    let oldstate = { ...state }


    return produce(oldstate, draft => {
      draft.language = newState.language;
    })
  }),
  on(ProfileStateAction.setName, (state, newState) => {
    let oldstate = { ...state }
    return produce(oldstate, draft => {
      draft.name = newState.name;
    })
  }),
  on(ProfileStateAction.setEmail, (state, newState) => {
    let oldstate = { ...state }

    return produce(oldstate, draft => {
      draft.email = newState.email;
    })
  }),

)
